module.exports = __webpack_public_path__ + "img/outros.f426c04d.svg";